<ng-container *transloco="let t; read: 'time-entries'" >
    <kendo-grid
    [data]="weekReportingObjects"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    [pageable]="true"
    (pageChange)="onPageChange($event)"
    [sortable]="sortable ? sortSettings : false"
    [sort]="sort"
    (sortChange)="onSortChange($event)"
    scrollable="none"
  >

    <kendo-grid-column
     media="(min-width: 450px)" field="startDate" [title]="t('week')">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.startDate | date: "dd.MM.yyyy"}} - {{ dataItem.endDate | date: "dd.MM.yyyy"}}
      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalWorkTimeObj || totalFlexTimeObj || totalPreWorkTimeObj || hasGrandTotals"
      >
        <div>{{ hasGrandTotals ? 'Total Seite' : 'Total' }}</div>
        <div *ngIf="hasGrandTotals">Total Auswahl</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
     media="(min-width: 450px)" 
     [title]="t('employee')"
     *ngIf="isAdminView"
     >
     <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employee.firstName }} {{ dataItem.employee.lastName}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="totalTimeWorked" [sortable]="false" [title]="t('workTime')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.totalTimeWorkedObj)">
          <span>{{dataItem.totalTimeWorkedObj?.factor < 0 && dataItem.totalTimeWorkedObj?.hours == 0 ? "-" :"" }}{{ dataItem.totalTimeWorkedObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.totalTimeWorkedObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>

      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalWorkTimeObj || grandWorkTimeObj"
      >
        <div *ngIf="totalWorkTimeObj">{{ totalWorkTimeObj.toStringShort() }}</div>
        <div *ngIf="grandWorkTimeObj">{{ grandWorkTimeObj.toStringShort() }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="flexTimeChange" [sortable]="false" [title]="t('flexTime')" width="100" *ngIf="showFlexPreWorkChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.flexTimeChangeObj)">
          <span>{{dataItem.flexTimeChangeObj?.factor < 0 && dataItem.flexTimeChangeObj?.hours == 0 ? "-" :"" }}{{ dataItem.flexTimeChangeObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.flexTimeChangeObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>

      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalFlexTimeObj || grandFlexTimeObj"
      >
        <div *ngIf="totalFlexTimeObj">{{ totalFlexTimeObj.toStringShort() }}</div>
        <div *ngIf="grandFlexTimeObj">{{ grandFlexTimeObj.toStringShort() }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="overtime" [sortable]="false" [title]="t('overtime')" width="100" *ngIf="showOvertime">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.overtimeObj)">
          <span>{{dataItem.overtimeObj?.factor < 0 && dataItem.overtimeObj?.hours == 0 ? "-" :"" }}{{ dataItem.overtimeObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.overtimeObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="timeSupplementTimeChange" [sortable]="false" [title]="t('supplements')" width="100" *ngIf="showtimeSupplementTimeChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.timeSupplementTimeChangeObj)">
          <span>{{dataItem.timeSupplementTimeChangeObj?.factor < 0 && dataItem.timeSupplementTimeChangeObj?.hours == 0 ? "-" :"" }}{{ dataItem.timeSupplementTimeChangeObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.timeSupplementTimeChangeObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>

      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="preWorkTimeChange" [sortable]="false" [title]="t('preWorkTime')" width="100" *ngIf="showFlexPreWorkChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.preWorkTimeChangeObj)">
          <span >{{ dataItem.preWorkTimeChangeObj?.hours }}</span
          ><span> h</span>
          <span> {{ (dataItem.preWorkTimeChangeObj?.minutes | number:'2.0')}}</span
          ><span> min</span>
        </div>
      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalPreWorkTimeObj || grandPreWorkTimeObj"
      >
        <div *ngIf="totalPreWorkTimeObj">{{ totalPreWorkTimeObj.toStringShort() }}</div>
        <div *ngIf="grandPreWorkTimeObj">{{ grandPreWorkTimeObj.toStringShort() }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
     media="(min-width: 450px)" [title]="t('signed')" field="signedBy" [sortable]="false" >
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.signedById">
          {{ dataItem.signedBy.firstName }} {{ dataItem.signedBy.lastName}} {{ dataItem.signedOn | date: "dd.MM.yyyy"}}
        </ng-container>
        <ng-container *ngIf="!dataItem.signedById && !isAdminView && !allDaysConfirmed(dataItem)">
          <button
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class="mbs mrs"
            (click)="onConfirmWeek(dataItem.id)"
            [disabled]="!canConfirmWeek(dataItem.endDate)"
            loadingIndication="/TimeEntry/confirmWeek"
          >
            {{t('confirmWeekButton')}}
          </button>
        </ng-container>
        <ng-container *ngIf="!dataItem.signedById && !isAdminView && allDaysConfirmed(dataItem)">
          {{ t('dayReport.confirmed') }}
        </ng-container>
        <!-- Not tied to the admin view: canSign covers one's own week (SelfSignEntry) as well. -->
        <ng-container *ngIf="!dataItem.signedById">
          <button
            *ngIf="canSign(dataItem)"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class="mbs mrs"
            (click)="onSignWeek(dataItem.id)"
            [disabled]="!canSignWeek(dataItem.endDate)"
            loadingIndication="/TimeEntry/signWeek"
          >
            {{t('signWeekButton')}}
          </button>
        </ng-container>
      </ng-template>
    </kendo-grid-column>
  
    <!-- Mobile View -->
    <kendo-grid-column media="(max-width: 450px)" [title]="t('weekReports')">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- template for mobile -->
        <kendo-formfield *ngIf="isAdminView">
          {{dataItem.employee.firstName + " " + dataItem.employee.lastName}}
        </kendo-formfield>
        <h4 [class.discontinued]="dataItem.Discontinued">
          {{ dataItem.startDate | date: "dd.MM.yyyy"}} - {{ dataItem.endDate | date: "dd.MM.yyyy"}}
        </h4>
        <ng-container *ngIf="dataItem.signedById">
          {{ dataItem.signedBy.firstName }} {{ dataItem.signedBy.lastName}} {{ dataItem.signedOn | date: "dd.MM.yyyy"}}
        </ng-container>
        <ng-container *ngIf="!dataItem.signedById && !isAdminView && !allDaysConfirmed(dataItem)">
          <button
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class=" mts mbs"
            (click)="onConfirmWeek(dataItem.id)"
            [disabled]="!canConfirmWeek(dataItem.endDate)"
            loadingIndication="/TimeEntry/confirmWeek"
          >
            {{t('confirmWeekButton')}}
          </button>
        </ng-container>
        <ng-container *ngIf="!dataItem.signedById">
          <button
            *ngIf="canSign(dataItem)"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class=" mts mbs"
            (click)="onSignWeek(dataItem.id)"
            [disabled]="!canSignWeek(dataItem.endDate)"
            loadingIndication="/TimeEntry/signWeek"
          >
            {{t('signWeekButton')}}
          </button>
        </ng-container>
        
        <!-- <dl>  
          <dt>Start</dt>
          <dd>
            <kendo-maskedtextbox
              [value]="dataItem.start"
              [mask]="mask"
              [readonly]="true"
            >
            </kendo-maskedtextbox>
          </dd>
  
          <dt>Stop</dt>
          <dd>
            <kendo-maskedtextbox
              [value]="dataItem.stop"
              [mask]="mask"
              [readonly]="true"
            >
            </kendo-maskedtextbox>
          </dd>
  
          <dt>Tätigkeit</dt>
          <dd>{{dataItem.timeEntryCategory?.name ?? "-"}}</dd>
        </dl> -->
      </ng-template>
    </kendo-grid-column>
  
    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <div class="flex flexDirRow">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <div>
        <label for="pageBtnGroup" class="mrs">{{ t('resultsPerPage') }}</label>
        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
          <button
            (click)="onPageSizeChange(pageSizes.Small)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Small"
            [toggleable]="true"
          >
            {{ pageSizes.Small }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Medium)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Medium"
            [toggleable]="true"
          >
            {{ pageSizes.Medium }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Large)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Large"
            [toggleable]="true"
          >
            {{ pageSizes.Large }}
          </button>
        </kendo-buttongroup>

        <button
          kendoButton
          [title]="t('refresh')"
          (click)="onGridReload()"
          icon="reload"
        ></button>
      </div>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t('noResults') }}</div>
    </ng-template>

    <ng-template kendoGridDetailTemplate let-dataItem>
      <app-day-reporting-grid
        [dayReportingObjects]="dataItem.dayReportingObjects"
        [isAdminView]="isAdminView"
        [isEditable]="dataItem.signedById == null"
        [showFlexPreWorkChanges]="showDayFlexPreWorkChanges"
        (onUpdateGrid)="onGridReload()"
      ></app-day-reporting-grid>
    </ng-template>
  
    
  </kendo-grid>
</ng-container>